import React from 'react';
import { useIntl } from 'react-intl';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  dateFormatter,
  dateTimeFormatter,
  infoFormatter,
  infoFormatterIntl,
  localeFormatter,
} from '../../../../utils/formatters';
import {
  PROCEDURE_TYPE,
} from '../../../../configs';
import FileView from '../../../../components/fields/FileInput/FileView';

export default function ApplicationInfoView(props) {
  const { formatMessage } = useIntl();
  const { currentApplication, fieldsValidation, isPreview } = props;
  const {
    procedure,
    document_submission_type,
    procedure_conducting_authority,
    delivery_method_extracts_from_register,
    apply_method,
    delivery_method_notification,
    notification_method,
    processing_time_limits,
    review_date,
    consider_apply_date,
    decision_deadline_date,
    comment,
    title,
    files = [],
  } = currentApplication;

  const apply_files = files && files.length ? files.find(item => item.collection_name === 'apply_files') : undefined;
  const list_of_documents = files && files.length ? files.find(item => item.collection_name === 'list_of_documents') : undefined;

  function PreviewApplicationInfoView() {
    return (
      <>
        <Row className="row-cols-2">
          {infoFormatterIntl('procedure.name', procedure ? formatMessage({ id: `procedure.type.${procedure}` }) : '')}
          {infoFormatterIntl(procedure === PROCEDURE_TYPE.PROCEDURE_kt_exlt ? 'mais_egu_id_alternative' : 'mais_egu_id', currentApplication.mais_egu_id || 'Без номера', fieldsValidation, 'mais_egu_id')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('applied_at', dateTimeFormatter(currentApplication.applied_at), fieldsValidation, 'applied_at')}
          {infoFormatterIntl('review_date', dateFormatter(review_date))}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('consider_apply_date', dateFormatter(consider_apply_date))}
          {infoFormatterIntl('media.apply_files', apply_files ? <FileView readOnly withoutMime withoutHr files={[apply_files]} /> : null, fieldsValidation, 'media.apply_files', 6)}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('list_of_documents', list_of_documents ? <FileView readOnly withoutMime withoutHr files={[list_of_documents]} /> : null, {}, '', 6)}
        </Row>
      </>
    );
  }

  function FullApplicationInfoView() {
    return (
      <>
        <Row className="row-cols-2">
          {infoFormatterIntl('procedure.name', procedure ? formatMessage({ id: `procedure.type.${procedure}` }) : '')}
          {infoFormatterIntl(procedure === PROCEDURE_TYPE.PROCEDURE_kt_exlt ? 'mais_egu_id_alternative' : 'mais_egu_id', currentApplication.mais_egu_id || 'Без номера', fieldsValidation, 'mais_egu_id')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('applied_at', dateTimeFormatter(currentApplication.applied_at), fieldsValidation, 'applied_at')}
          {infoFormatterIntl('application.created_at', dateTimeFormatter(currentApplication.created_at))}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('application.updated_at', dateTimeFormatter(currentApplication.updated_at))}
          {infoFormatter('Срок проведения услуги', processing_time_limits)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('decision_deadline_date', dateFormatter(decision_deadline_date))}
          {infoFormatterIntl('review_date', dateFormatter(review_date))}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('consider_apply_date', dateFormatter(consider_apply_date))}
          {infoFormatterIntl('apply_method', localeFormatter('apply.method.type', apply_method), fieldsValidation, 'apply_method')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('media.apply_files', apply_files ? <FileView readOnly withoutMime withoutHr files={[apply_files]} /> : null, fieldsValidation, 'media.apply_files', 6)}
          {infoFormatterIntl('document_submission_type', localeFormatter('document.submission.type', document_submission_type), fieldsValidation, 'document_submission_type')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('procedure_conducting_authority', procedure_conducting_authority, fieldsValidation, 'procedure_conducting_authority')}
          {infoFormatterIntl('delivery_method_extracts_from_register', localeFormatter('delivery.method.type', delivery_method_extracts_from_register), fieldsValidation, 'delivery_method_extracts_from_register')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('delivery_method_notification', localeFormatter('delivery.method.type', delivery_method_notification), fieldsValidation, 'delivery_method_notification')}
          {infoFormatterIntl('notification_method', localeFormatter('notification.method.type', notification_method), fieldsValidation, 'notification_method')}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('list_of_documents', list_of_documents ? <FileView readOnly withoutMime withoutHr files={[list_of_documents]} /> : null, {}, '', 6)}
        </Row>
      </>
    );
  }

  return (
    <>
      {title && <div className="f4">Информация об обращении</div>}
      {isPreview ? <PreviewApplicationInfoView /> : <FullApplicationInfoView />}
    </>
  );
}
